import React, { lazy } from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María Laura G.',
  city: 'La Plata, Buenos Aires',
  text: 'Nunca pensé que iba a tener todo tan organizado para la intensificación. El MegaPack me salvó. Lo descargué el domingo y el lunes ya estaba lista para arrancar.',
  avatar: 'https://cdn.magicpatterns.com/uploads/7sN1jxDqRh2cpL67WQXhzf/Testimonio_1.png',
  borderColor: 'border-[#00BCD4]'
}, {
  name: 'Claudia R.',
  city: 'Mar del Plata, Buenos Aires',
  text: 'Las rúbricas y las guías de actividades son exactamente lo que necesitaba. Además, está todo alineado con los diseños curriculares. ¡Increíble!',
  avatar: 'https://cdn.magicpatterns.com/uploads/iw6CeABY6istJ24aU6bNS6/testimonio_2.png',
  borderColor: 'border-white'
}, {
  name: 'Sergio M.',
  city: 'Bahía Blanca, Buenos Aires',
  text: 'Como docente de Matemática, dudé al principio. Pero cuando vi la calidad del material y los bonos incluidos, no lo dudé más. Vale cada peso.',
  avatar: 'https://cdn.magicpatterns.com/uploads/uQuadGdpTbTWXdYf6MZScr/Testimonio_3.png',
  borderColor: 'border-gray-300'
}];
export function TestimonialsSection() {
  return <section className="bg-[#F9F9F9] py-20 px-4" data-id="element-188">
      <div className="max-w-6xl mx-auto" data-id="element-189">
        <div className="text-center mb-16" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A]" data-id="element-191">
            Lo que dicen otros docentes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-192">
          {testimonials.map((t, index) => <div key={index} className="bg-white rounded-[16px] p-8 shadow-sm border border-[#00BCD4]/15 flex flex-col items-center text-center" data-id="element-193">
              {/* Avatar */}
              <div className={`w-20 h-20 rounded-full overflow-hidden mb-5 border-[3px] ${t.borderColor} shadow-md`} data-id="element-194">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" width="80" height="80" loading="lazy" decoding="async" data-id="element-195" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-196">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#FFD54F] text-[#FFD54F]" data-id="element-197" />)}
              </div>

              {/* Name */}
              <h4 className="font-bold text-[#00BCD4] text-lg" data-id="element-198">{t.name}</h4>

              {/* City */}
              <p className="text-sm text-gray-500 mb-4" data-id="element-199">{t.city}</p>

              {/* Testimonial */}
              <p className="text-gray-600 italic leading-relaxed flex-grow" data-id="element-200">
                "{t.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}